'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CopyText = function (_Component) {
  _inherits(CopyText, _Component);

  function CopyText() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CopyText);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CopyText.__proto__ || Object.getPrototypeOf(CopyText)).call.apply(_ref, [this].concat(args))), _this), _this.state = { copying: false }, _this.onInputRef = function (ref) {
      if (!ref) return;
      ref.select();
      document.execCommand('copy');
      _this.setState({ copying: false });
      if (_this.props.onCopied) _this.props.onCopied(_this.props.text);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CopyText, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.text && this.props.text !== nextProps.text) {
        this.setState({ copying: true });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.state.copying ? _react2.default.createElement('input', { ref: this.onInputRef, value: this.props.text, readOnly: true }) : null;
    }
  }]);

  return CopyText;
}(_react.Component);

CopyText.propTypes = {
  text: _propTypes2.default.string,
  onCopied: _propTypes2.default.func
};
exports.default = CopyText;


//////////////////
// WEBPACK FOOTER
// ./~/react-copy-text/lib/CopyText.js
// module id = 1827
// module chunks = 0